import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { makeRequest } from "../../utils/request";
import { getUrlWithoutPathname } from "../../utils/utility";
import {
  getAdobeAnalyticsEventObject,
  getAdobeAnalyticsCustomLinkObj,

} from '../../analytics/analyticsObject';
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
const PlanCard = ({
  header,
  price,
  tagline,
  paypayId,
  color,
  planId,
  onStart,
  onEnd,
  onError,
  hasSubscribeButton,
  paypalLoaded,
  isMember,
  isFree = false,
}) => {
  const history = useHistory();

  useEffect(() => {
    if (paypalLoaded && planId) {
      window.paypal
        .Buttons({
          createSubscription: function (data, actions) {
            return actions.subscription.create({
              plan_id: planId,
            });
          },

          onApprove: async function (data, actions) {
            onStart();
            const plan = await makeRequest("post", "/api/subscriptions", {
              id: data.subscriptionID,
            });
            onEnd(plan);
          },
        })
        .render(`#${paypayId}`);
    }
  }, [paypalLoaded, planId]);

  const freeSubscribe = async () => {
    if (isMember || isFree) {
      onStart();
      makeRequest("post", "/api/subscriptions/free")
        .then((res) => {
          // history.push("/home");
          onEnd(res);
        })
        .catch((err) => {
          onError(err);
        });
    }
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let url = getUrlWithoutPathname()
    let customLObj = getAdobeAnalyticsCustomLinkObj('subscribe now', "landing-page", url);
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      // pageData: false,
      adobePushTracking: false,
    });
  };

  return (
    <>
      <div
        className={`flex flex-col w-full lg:w-1/2 rounded overflow-hidden shadow-lg lg:mr-4 mb-8 px-6 py-8 bg-white border-t-8 ${color}`}
        adoberegion="landing-page" >
        <span className={`text-xl mb-4 font-bold`}>{header}</span>

        <span className={`text-3xl mb-4`}>
          {price ? (
            <p>
              <span className="font-bold">US${price}</span> / month
            </p>
          ) : (
            <span className="font-bold">Free</span>
          )}
        </span>

        {tagline && <span className={`text-xl mb-4`}>{tagline}</span>}
        {hasSubscribeButton && (
          <button
            className={
              "w-full h-12 bg-orange-brand-500 rounded text-white font-bold text-xl mt-auto " +
              (isMember || isFree
                ? "hover:bg-gray-900"
                : "opacity-50 cursor-not-allowed")
            }
            onClick={freeSubscribe}
          >
            Subscribe Now
          </button>
        )}
        {paypayId && !isMember && (
          <>
            <hr className="w-full border-t-4 mb-4" />
            <span className={`mb-4`}>Checkout with paypal</span>
            <div id={paypayId} />
          </>
        )}
      </div>
    </>
  );
};

export default PlanCard;
